import { z } from 'zod'

export const baseOptionSchema = z.object({
  /** 選項顯示文字(UI) */
  label: z.string(),
  /** 選項 Value */
  value: z.string(),
  /** 唯獨時選項顯示文字，未設定時使用 label(UI) */
  readonlyLabel: z.string().optional(),
  /** 欄位是否不能選擇 */
  disabled: z.boolean().optional()
})

export type BaseOption<
  T extends number | string | boolean | undefined = string
> = Omit<z.infer<typeof baseOptionSchema>, 'value'> & {
  value: T
}
